// extracted by mini-css-extract-plugin
export var icon = "_ww-0";